import React from 'react';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="pt-32 pb-20 bg-gradient-to-b from-cyan-50 via-purple-50 to-white" aria-labelledby="hero-title">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 
            id="hero-title"
            className="text-5xl font-bold mb-6 bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent"
          >
            {t.hero.title}
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            {t.hero.description}
          </p>
          <div className="flex justify-center space-x-4">
            <a 
              href="#services"
              className="px-8 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 text-white rounded-lg hover:from-cyan-600 hover:to-purple-700 transition-all flex items-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
              aria-label={t.hero.cta}
            >
              <Sparkles className="w-5 h-5 mr-2" aria-hidden="true" />
              {t.hero.cta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;